import React from 'react';
import InstrumentSelectorContainer from '../InstrumentSelector/InstrumentSelectorContainer';
import InstrumentTableContainer from '../InstrumentTable/InstrumentTableContainer';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import './InstrumentRowComponent.css';
var baseClasses = getBEMClasses('instrument-row');
var InstrumentRowComponent = function InstrumentRowComponent() {
  return React.createElement('div', {
    className: baseClasses()
  }, React.createElement(InstrumentSelectorContainer, null), React.createElement(InstrumentTableContainer, null));
};
export default InstrumentRowComponent;